/* eslint-disable arrow-parens */
import React, { Component } from 'react';
import { push } from 'react-router-redux'
import { store } from '../../stores/configureStore';
import { IconButton } from 'material-ui';
import Box from '../ui/Box';

//services
import LocalStorageService from '../../services/LocalStorageService'; var ls = LocalStorageService;
import DataService from '../../services/DataService';
var ds = DataService;


export default class RoomsConsolidated extends Component {
  constructor() {
    super();
    this.state = {
      all_rooms: [],
      rooms_map: {}
    };
  }

  componentDidMount() {
    this.startFunc();
  }

  startFunc() {
    this.getAllRooms();
    this.getStatuses();
  }

  getAllRooms() {
    ds.getSomeRooms(ls.getUserDetails().hotel_id, 0, 0,
      data => {
        let x = {};
        for (let i of data) {
          let room_is_empty = true;
          let check_out_string = "";
          if (i.check_in_time && i.check_out_time) {
            let cell = i.check_in_time;
            let x = new Date(cell);
            let y = new Date(i.check_out_time);
            let today = new Date();
            if(x<=today && y>today ){
              room_is_empty = false;  
              check_out_string = y.getDate()+'/'+y.getMonth()+'/'+y.getFullYear();
            } else {
              room_is_empty = true;
            }
          } else {
            room_is_empty = true;
          }
          if (i.hotel_room_id) {
            if (!x[i.hotel_room_id.floor]) {
              x[i.hotel_room_id.floor] = [];
            }
            x[i.hotel_room_id.floor].push({...i,room_is_empty:room_is_empty,check_out_string:check_out_string});
          }
        }
        let all_rooms = [];
        for (const i in x) {
          all_rooms.push({
            name: i,
            rooms: x[i]
          })
        }
        this.setState({
          all_rooms: all_rooms
        });
      }, err => {
        console.log(err);
      })
  }
  getStatuses() {
    ds.getRoomStatuses(ls.getUserDetails().hotel_id,
      data => {
        let x = {};
        if (data && data.length) {
          for (let i of data) {
            x[i.room_id] = i;
          }
        }
        this.setState({
          rooms_map: x
        })
      }, err => {
        console.log(err);
      })
  }

  goToRoomControl(room) {
    store.dispatch(push(`/app/rooms/control/${room._id}_${room.hotel_room_id ? room.hotel_room_id._id : ''}`));
  }

  render() {
    return (
      <div>
        <Box header='All Rooms'>

          <IconButton aria-label="Refresh" onClick={this.startFunc.bind(this)} className='customRefresh'>
            <i className="material-icons">refresh</i>
          </IconButton>

          {
            this.state.all_rooms && this.state.all_rooms.length ?
              this.state.all_rooms.map((floor, ind) => {
                if (floor.rooms && floor.rooms.length) {
                  return <div className="col-sm-12">
                    {
                      this.state.all_rooms.length > 1 ? 
                        <div style={{ color: "black", marginLeft: "1vw", marginBottom: "1vw", marginTop: "1vw", fontSize: "1.3rem" }}>
                          {floor.name && floor.name != 'undefined' ? "Floor " + floor.name : 'Other'}
                        </div> 
                      : null
                    }
                    {
                      floor.rooms.map((room, ind2) => {
                      return room.hotel_room_id ? 
                        <div key={room._id} className="col-xl-3 col-sm-6" style={{ cursor: "pointer" }} onClick={this.goToRoomControl.bind(this, room)}>
                          <div className="box box-default customBox">
                          <div style={{textAlign: "end"}}>
                            {room.room_is_empty ? 
                            <i className="material-icons" style={{color: 'green', margin: '5px', fontSize: '1.5rem'}}>done</i> :
                             <div><span style={{position: 'relative',top: '-4px'}}>{room.check_out_string}</span> <i className="material-icons" style={{color: 'red', margin: '5px', fontSize: '1.5rem'}}>do_not_disturb</i></div>
                             }
                             </div>
                            <div className="box-top">
                              <span> {this.state.rooms_map[room.hotel_room_id._id] ? this.state.rooms_map[room.hotel_room_id._id].activeAppliances : 0}<span className="green-fg" style={{ fontSize: "0.7rem", marginLeft: "0.2vw" }}>ON</span> </span>
                            </div>

                            <div className="box-info">
                              <span style={{ fontSize: "1.5rem", height: "30px", lineHeight: "23px" }}>{room.hotel_room_id.name}</span>
                            </div>

                            <div className="box-bottom row" style={{ fontSize: "1.7rem", padding: "1vw", height: "70px", paddingTop: "1.5vw", margin: 0 }}>
                              <div className="col-md-6 col-6">{this.state.rooms_map[room.hotel_room_id._id] ? this.state.rooms_map[room.hotel_room_id._id].totalAppliances - this.state.rooms_map[room.hotel_room_id._id].activeAppliances : 0} <span style={{ fontSize: "0.7rem" }} className="warn-fg">OFF</span></div>
                              <div className="col-md-6 col-6"> {this.state.rooms_map[room.hotel_room_id._id] ? this.state.rooms_map[room.hotel_room_id._id].totalAppliances : 0} <span style={{ fontSize: "0.7rem", color: "$gray-600" }}>TOTAL</span></div>
                            </div>
                          </div>
                        </div> 
                      : null
                      })
                    }
                  </div>
                }
                else {
                  return null;
                }
              })
            : "No Roooms Found :("
          }
        </Box>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./components/rooms/RoomsConsolidated.js